/* Penis Enlargement Cost + Methods pages. Tabs, click-to-load YouTube, and window.PEC: the core for the cost calculator (pec-calc-a.js). */
(function () {
  // click-to-load YouTube (both pillar pages)
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.pec-yt__b');
    if (!b) return;
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + b.getAttribute('data-yt') + '?autoplay=1&rel=0&start=' + (b.getAttribute('data-start') || 0);
    f.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'; f.allowFullscreen = true; f.title = b.getAttribute('aria-label') || 'Video';
    b.replaceWith(f);
  });
  // tabs: every panel is in the HTML (search engines read them all); JS only hides inactive panels
  function tabsets() { return [].slice.call(document.querySelectorAll('[data-tabset]')); }
  function activate(ts, id) {
    var tps = ts.querySelector(':scope > [data-tps]');
    if (!tps) return;
    [].forEach.call(tps.children, function (p) { p.classList.toggle('on', p.id === id); });
    [].forEach.call(ts.querySelectorAll(':scope > .pec-tabs > .pec-tab'), function (b) {
      var on = b.getAttribute('data-t') === id; b.classList.toggle('on', on); b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }
  function openTarget(id, scroll) {
    var el = document.getElementById(id);
    if (!el) return false;
    var n = el, chain = [];
    while (n && n !== document.body) {
      if (n.parentElement && n.parentElement.hasAttribute('data-tps')) chain.push(n);
      n = n.parentElement;
    }
    chain.reverse().forEach(function (p) { activate(p.parentElement.parentElement, p.id); });
    if (scroll) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  }
  tabsets().forEach(function (ts) {
    var tps = ts.querySelector(':scope > [data-tps]');
    if (!tps || !tps.children.length) return;
    tps.classList.add('js-tabs');
    activate(ts, tps.children[0].id);
    ts.querySelector(':scope > .pec-tabs').addEventListener('click', function (e) {
      var b = e.target.closest('.pec-tab'); if (!b) return;
      activate(ts, b.getAttribute('data-t'));
      var inner = document.getElementById(b.getAttribute('data-t'));
      var sub = inner && inner.querySelector('[data-tabset]');
      if (sub) { var st = sub.querySelector(':scope > [data-tps]'); if (st && st.children.length) activate(sub, st.children[0].id); }
    });
  });
  if (location.hash.length > 1) openTarget(location.hash.slice(1), true);
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a || a.getAttribute('href').length < 2) return;
    var id = a.getAttribute('href').slice(1), el = document.getElementById(id);
    if (!el || !el.closest('[data-tps]')) return;
    e.preventDefault(); openTarget(id, true); history.replaceState(null, '', '#' + id);
  });


  // ---------------------------------------------------------------- calculator core (data from #pec-data, built by gen_cost.py)
  var dataEl = document.getElementById('pec-data');
  if (!dataEl) return;
  var D = JSON.parse(dataEl.textContent);
  var P = {}; try { P = JSON.parse(document.getElementById('pec-prod').textContent); } catch (err) {}
  var M = {}, E = {}, C = {};
  D.methods.forEach(function (m) { M[m.id] = m; });
  D.epic.forEach(function (e) { E[e.id] = e; });
  D.countries.forEach(function (c) { C[c.s] = c; });
  var HOME = { length: 'epic_pro', girth: 'epic_pump', both: 'epic_air' };
  var REDDIT = { ha: ['ha_filler', 'filler_unspecified'], combo: ['surgery_unspecified'], pmma: ['pmma'], fat: ['fat_transfer'], penuma: ['penuma', 'penuma_removal'] };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function usd(v) { return '$' + Math.round(v).toLocaleString('en-US'); }
  function local(v, cur) {
    var r = cur && cur !== 'USD' && D.fx && D.fx.rates && D.fx.rates[cur];
    if (!r || isNaN(r)) return '';
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur, maximumFractionDigits: 0 }).format(v * r); } catch (err) { return ''; }
  }
  function cname(c) { return c.n.replace(/^the /, '').replace(/^./, function (x) { return x.toUpperCase(); }); }
  function inName(c) { return c.n.indexOf('the ') === 0 ? c.n : cname(c); }
  function flag(iso, lg) { return '<i class="pec-f' + (lg ? ' pec-f--lg' : '') + ' pec-f--' + esc(iso) + '" aria-hidden="true"></i>'; }
  function icon(n, s) {
    s = s || 20;
    return '<svg class="pck-i" width="' + s + '" height="' + s + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (D.icons[n] || '') + '</svg>';
  }
  function yrs(y) { return y + (y === 1 ? ' year' : ' years'); }
  function cell(id, s) { var p = (D.prices[s] || {})[id]; return p || null; }
  function priced(id, s) { var p = cell(id, s); return !!(p && (p.st === 'verified' || p.st === 'estimate')); }
  // total cost of a method in a country, kept y years. Fillers add a top-up every m.every months. Epic = the device price, paid once.
  function cost(id, s, y) {
    var e = E[id];
    if (e) return { lo: e.usd, hi: e.usd, typ: e.usd, first: e.usd, extra: 0, epic: true, tops: 0 };
    var m = M[id], p = cell(id, s);
    if (!m || !p || !(p.st === 'verified' || p.st === 'estimate')) return null;
    var tops = m.model === 'repeat' ? Math.floor(y * 12 / m.every) : 0, f = 1 + tops * (m.topup || 0);
    return { lo: p.lo * f, hi: p.hi * f, typ: p.typ * f, first: p.typ, extra: p.typ * (f - 1), n: p.n, tops: tops, est: p.st === 'estimate', basis: p.basis, offered: p.offered };
  }
  // only fillers and shots fade, so only they need a "keep it for" choice
  function repeats(id) { var m = M[id]; return !!(m && m.model === 'repeat'); }
  function fits(m, goal) { return goal === 'both' || m.goal === goal || m.goal === 'both'; }
  function home(goal) { return E[HOME[goal] || 'epic_air']; }
  function paid(id) { var k = REDDIT[id] || []; return D.reddit.filter(function (r) { return k.indexOf(r.method) > -1; }); }
  // visitor's country: GeoJS (the same service as the store's shipping messages), then Shopify's own guess, then the USA.
  // Liquid's localization.country is not used: Shopify's page cache served other visitors' countries.
  // A country without prices maps to the nearest one that has them (D.near, built by gen_cost.py).
  function geoSlug(iso) {
    iso = (iso || '').toLowerCase();
    var hit = D.countries.filter(function (c) { return c.iso === iso; })[0];
    return hit ? hit.s : (D.near && C[D.near[iso]] ? D.near[iso] : '');
  }
  function geoSaved() { try { return geoSlug(sessionStorage.getItem('pec_geo')); } catch (err) { return ''; } }
  function geo() { return geoSaved() || 'usa'; }
  // cb(slug, or '' if unknown) once, within ms. A late answer is still saved for the next page view.
  function geoFetch(cb, ms) {
    var done = false;
    function fin(iso) {
      if (iso) { try { sessionStorage.setItem('pec_geo', String(iso).toLowerCase()); } catch (err) {} }
      if (done) return;
      done = true; cb(geoSlug(iso));
    }
    function get(u) { return fetch(u, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); }
    setTimeout(function () { fin(''); }, ms || 1500);
    get('https://get.geojs.io/v1/ip/country.json').then(function (d) { if (!d || !d.country) throw new Error('no country'); fin(d.country); })
      .catch(function () { return get('/browsing_context_suggestions.json').then(function (d) { fin(d && d.detected_values && d.detected_values.country && d.detected_values.country.handle); }); })
      .catch(function () { fin(''); });
  }
  function countUp(el, to, fmt) {
    fmt = fmt || usd;
    var from = el._v == null ? to * 0.6 : el._v, t0 = null;
    el._v = to;
    if (!window.requestAnimationFrame || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) || from === to) { el.textContent = fmt(to); return; }
    cancelAnimationFrame(el._raf);
    (function step(t) {
      if (t0 === null) t0 = t;
      var k = Math.min(1, (t - t0) / 650); k = 1 - Math.pow(1 - k, 3);
      el.textContent = fmt(from + (to - from) * k);
      if (k < 1) el._raf = requestAnimationFrame(step);
    })(performance.now());
  }

  // country picker. o = { value, onPick(slug), note(country) -> html, filter(country) -> bool, button: html shown instead of the value }
  // country selector: the visible box is only a label. A see-through native <select> sits on top of it, so a tap opens
  // the phone's own picker (no dropdown, no search box). o = { value, label, onPick(slug) }.
  function picker(box, o) {
    box.classList.add('pec-cp');
    var opts = D.regions.map(function (r) {
      var cs = D.countries.filter(function (c) { return c.r === r; }).sort(function (a, b) { return cname(a).localeCompare(cname(b)); });
      return cs.length ? '<optgroup label="' + esc(r) + '">' + cs.map(function (c) { return '<option value="' + c.s + '">' + esc(cname(c)) + '</option>'; }).join('') + '</optgroup>' : '';
    }).join('');
    box.innerHTML = '<span class="pec-cp__btn" aria-hidden="true"><span class="pec-cp__v"></span>' + icon('chev', 16).replace('pck-i', 'pck-i pec-cp__chev') + '</span>' +
      '<select class="pec-cp__sel" aria-label="' + esc(o.label || 'Country') + '">' + opts + '</select>';
    var val = box.querySelector('.pec-cp__v'), sel = box.querySelector('select'), api = { value: o.value };
    function set(s) {
      var c = C[s]; if (!c) return;
      api.value = s; sel.value = s; val.innerHTML = flag(c.iso) + '<span>' + esc(cname(c)) + '</span>';
    }
    sel.addEventListener('change', function () { set(sel.value); if (o.onPick) o.onPick(sel.value); });
    api.set = set;
    set(o.value);
    return api;
  }

  // at-home card: product photo, name + price, then checkmark benefits (the saving against the clinic total first; y = years, only when
  // the clinic option fades). Claims match the site: harder/stronger erections (pump vs pages, extender guide), safest = outside the body (methods FAQ).
  var GAINS = { epic_pump: 'More girth gain over time', epic_pro: 'More length gain over time', epic_air: 'More length and girth gain over time' };
  var PERKS = ['At home and private', 'Stronger erections', 'Safest option, no needles or surgery'];
  function homeCard(goal, y, vs, where) {
    var e = home(goal), p = P[e.id] || {}, save = vs ? vs - e.usd : 0;
    var ok = (save > 0 ? ['<b>' + usd(save) + ' less than ' + esc(where || 'the clinic') + (y ? ' over ' + yrs(y) : '') + '</b>'] : [])
      .concat([GAINS[e.id] || 'More gain over time'].concat(PERKS).map(esc));
    return '<div class="pck-home">' + (p.img ? '<a class="pck-home__img" href="' + esc(p.url || e.link) + '"><img src="' + esc(p.img) + '" alt="' + esc(e.name) + '" width="200" height="200" loading="lazy"></a>' : '') +
      '<div class="pck-home__b"><p class="pck-home__n">' + esc(e.name) + ' <b>' + usd(e.usd) + '</b> <span>paid once</span></p>' +
      '<ul class="pck-home__ok">' + ok.map(function (t) { return '<li>' + icon('check', 16) + '<span>' + t + '</span></li>'; }).join('') + '</ul>' +
      '<div class="pck-home__a"><a class="pec-btn" href="' + esc(p.url || e.link) + '">See the ' + esc(e.short) + '</a><span>' + icon('shield', 16) + '180-day money back guarantee</span></div></div></div>';
  }


  // email: Klaviyo "Lead Magnet Subcribers" list (its welcome flow sends Coach Chez's secret routine) + profile properties for the report.
  // The "PE Cost Report" event carries the whole report (evt) for the report email flow. Client API only (the legacy track/identify calls are retired).
  // ?dry=1 skips the network (for testing the UI) and leaves the payload in window.__pecLast.
  function subscribe(email, props, evt) {
    var CO = 'QXesPb', LIST = 'XNn9MW', pr = { $email: email }, ev = {}, k;
    for (k in props) { pr[k] = props[k]; ev[k] = props[k]; }
    for (k in evt || {}) ev[k] = evt[k];
    if (/[?&]dry=1/.test(location.search)) { window.__pecLast = { props: props, event: ev }; return Promise.resolve('dry'); }
    try { if (window._learnq) window._learnq.push(['identify', pr]); } catch (err) {}
    function post(path, data) {
      return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + CO, {
        method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', revision: '2024-10-15' }, body: JSON.stringify({ data: data })
      }).catch(function () {});
    }
    try {
      post('events', { type: 'event', attributes: { properties: ev, metric: { data: { type: 'metric', attributes: { name: 'PE Cost Report' } } },
        profile: { data: { type: 'profile', attributes: { email: email } } } } });
      return post('subscriptions', { type: 'subscription', attributes: { custom_source: 'PE Cost Calculator', profile: { data: { type: 'profile', attributes: { email: email, properties: props } } } },
        relationships: { list: { data: { type: 'list', id: LIST } } } });
    } catch (err) { return Promise.resolve(); }
  }
  // ---------------------------------------------------------------- full report + email gate, shared by all 3 versions
  // o = { g: goal, cs: [country slugs], y: years (0 = one-time prices), list: [methods], first: method id shown unblurred, sub: optional line under the title }.
  // Only an email unlocks it (Marko 2026-10-15 removed "No thanks"). The unlock is remembered for this visitor, so a new calculation stays open.
  var REP = { open: false, email: '', o: null };
  try { var sv = JSON.parse(localStorage.getItem('pec_report') || 'null'); if (sv && sv.email) { REP.open = true; REP.email = sv.email; } } catch (err) {}
  function cap(t) { return t.charAt(0).toUpperCase() + t.slice(1); }
  function repTable(o) {
    var e = home(o.g);
    var head = '<tr><th scope="col">Method</th>' + o.cs.map(function (s) { return '<th scope="col">' + flag(C[s].iso) + ' ' + esc(cname(C[s])) + '</th>'; }).join('') + '</tr>';
    var rows = o.list.map(function (m, i) {
      return '<tr' + (!REP.open && i > 0 ? ' class="pcb-blur"' : '') + '><th scope="row">' + esc(m.name) + '<small>' + esc(cap(m.kind)) + '</small></th>' + o.cs.map(function (s) {
        var c = cost(m.id, s, o.y), p = cell(m.id, s);
        if (c) return '<td>' + (c.est ? '<em>est</em> ' : '') + usd(c.typ) + '</td>';
        return '<td class="pcb-na">' + (p && p.st === 'banned' ? 'Banned' : 'Not offered') + '</td>';
      }).join('') + '</tr>';
    }).join('');
    rows += '<tr class="pcb-epic' + (REP.open ? '' : ' pcb-blur') + '"><th scope="row">' + esc(e.name) + '<small>at home, paid once</small></th>' + o.cs.map(function () { return '<td>' + usd(e.usd) + '</td>'; }).join('') + '</tr>';
    return '<div class="pcb-tw"><table class="pcb-t"><thead>' + head + '</thead><tbody>' + rows + '</tbody></table></div>' +
      '<p class="pcb-fine">' + (o.y ? 'Total for ' + yrs(o.y) + ', in USD. Fillers include their top-ups.' : 'One-time price, in USD.') + ' <em>est</em> means no clinic there posts a price, so we estimate it. Travel not included.</p>';
  }
  function repCards(o, list) {
    return '<div class="pcb-mcs">' + list.map(function (m) {
      var rr = paid(m.id).slice(0, 2), best = null;
      o.cs.forEach(function (s) { var c = cost(m.id, s, o.y); if (c && (!best || c.typ < best.c.typ)) best = { s: s, c: c }; });
      return '<div class="pcb-mc"><p class="pcb-mc__n">' + esc(m.name) + (best ? '<b>' + usd(best.c.typ) + '<small>in ' + esc(cname(C[best.s])) + '</small></b>' : '') + '</p>' +
        '<p class="pcb-mc__v">' + esc(m.verdict) + '</p><dl>' +
        [['Gain', m.gain], ['Lasts', m.lasts], ['Downtime', m.downtime], ['Risks', m.risk]].map(function (r) { return '<div><dt>' + r[0] + '</dt><dd>' + esc(r[1]) + '</dd></div>'; }).join('') + '</dl>' +
        (rr.length ? '<ul class="pcb-mc__paid">' + rr.map(function (r) { return '<li' + (r.outcome === 'regret' ? ' class="bad"' : '') + '><b>' + usd(r.usd) + '</b> ' + esc(r.detail) + '</li>'; }).join('') + '</ul>' : '') + '</div>';
    }).join('') + '</div>';
  }
  var BONUS = 'Bonus audio from Coach Chez, our PE coach for over 10 years. He shares the secret routine he gives his clients for the fastest gains.';
  var BENEFITS = ['Every price for your countries and methods', 'What each one adds and how long it lasts', 'Risks, downtime and what men on Reddit paid', BONUS];
  var fN = 0;
  function repForm(cta) {
    var id = 'pck-em' + (++fN);
    return '<form class="pcb-form" data-form novalidate><label class="pcb-sr" for="' + id + '">Email</label><span class="pcb-form__in">' + icon('mail', 18) +
      '<input id="' + id + '" type="email" name="email" autocomplete="email" inputmode="email" placeholder="Your email" required></span>' +
      '<button type="submit" class="pec-btn">' + esc(cta) + '</button><p class="pcb-form__err" data-err hidden>Please check your email.</p>' +
      '<p class="pcb-form__fine">Free. We send the routine and our best tips. Unsubscribe any time.</p></form>';
  }
  // n = blurred rows. The gate sits up over them (CSS uses --n), so the first row stays readable.
  function repGate(n) {
    return '<div class="pcb-gate" style="--n:' + n + '"><div class="pcb-gate__t"><p class="pcb-gate__h">' + icon('lock', 22) + 'Unlock your full report</p>' +
      '<ul>' + BENEFITS.slice(0, 3).map(function (b) { return '<li>' + icon('check', 16) + '<span>' + esc(b) + '</span></li>'; }).join('') + '</ul></div>' +
      '<p class="pcb-gate__b">' + icon('audio', 18) + '<span>' + esc(BONUS) + '</span></p>' + repForm('Unlock my report') + '</div>';
  }
  function repDone() {
    return '<div class="pcb-done">' + icon('check', 20) + '<div><p><b>Unlocked.</b> Coach Chez’s audio routine is on its way to <b>' + esc(REP.email) + '</b>.</p>' +
      '<a class="pec-btn pec-btn--ghost" href="' + (P.routine || '/pages/secret-routine') + '" target="_blank" rel="noopener">Open the routine now</a></div></div>';
  }
  function report(o) {
    REP.o = o;
    if (!o.list.length) return '';
    // the method he picked stays readable, the rest blur until he unlocks
    var first = o.list.filter(function (m) { return m.id === o.first; }), list = first.concat(o.list.filter(function (m) { return m.id !== o.first; }));
    var sub = o.sub ? '<p class="pcb-rep__s">' + esc(o.sub) + '</p>' : '';
    o = { g: o.g, cs: o.cs, y: o.y, list: list };
    REP.o = o;
    return '<div class="pcb-rep' + (REP.open ? '' : ' is-locked') + '"><p class="pcb-rep__h">Your full report</p>' + sub + (REP.email ? repDone() : '') + repTable(o) +
      (REP.open ? repCards(o, list) : repGate(list.length)) + '</div>';
  }
  // what goes on the Klaviyo profile with the email (extra = version-specific properties)
  function repProps(extra) {
    var o = REP.o || { cs: [], list: [], y: 0, g: 'both' }, all = [];
    o.list.forEach(function (m) { o.cs.forEach(function (s) { var c = cost(m.id, s, o.y); if (c) all.push({ m: m, s: s, c: c }); }); });
    all.sort(function (a, b) { return a.c.typ - b.c.typ; });
    var e = home(o.g), pr = {
      pe_cost_goal: o.g, pe_cost_countries: o.cs.map(function (s) { return cname(C[s]); }).join(', '), pe_cost_years: o.y || '',
      pe_cost_low_usd: all.length ? Math.round(all[0].c.typ) : '', pe_cost_high_usd: all.length ? Math.round(all[all.length - 1].c.typ) : '',
      pe_cost_cheapest: all.length ? all[0].m.name + ' in ' + cname(C[all[0].s]) + ' ' + usd(all[0].c.typ) : '', pe_cost_home: e.name + ' ' + usd(e.usd), pe_cost_url: location.href
    }, k;
    for (k in extra || {}) pr[k] = extra[k];
    return pr;
  }
  // the whole report for the email (event only, not the profile): one row per method, p = one price per country column, in the order on the page
  function repData() {
    var o = REP.o; if (!o) return {};
    var e = home(o.g);
    return {
      pe_cost_goal_name: o.g === 'both' ? 'Length and girth' : cap(o.g),
      pe_cost_cols: o.cs.map(function (s) { return cname(C[s]); }),
      pe_cost_rows: o.list.map(function (m) {
        return { n: m.name, k: cap(m.kind), g: m.gain, l: m.lasts, d: m.downtime, r: m.risk, p: o.cs.map(function (s) {
          var c = cost(m.id, s, o.y), p = cell(m.id, s);
          return c ? (c.est ? 'est ' : '') + usd(c.typ) : (p && p.st === 'banned' ? 'Banned' : 'Not offered');
        }) };
      }),
      pe_cost_epic: { n: e.name, p: usd(e.usd) },
      pe_cost_note: (o.y ? 'Total for ' + yrs(o.y) + ', in USD. Fillers include their top-ups.' : 'One-time price, in USD.') + ' "est" means no clinic there posts a price, so we estimate it. Travel not included.'
    };
  }
  // listens inside box for the email form. extra() = version-specific properties, redraw() re-renders the version.
  function bindReport(box, extra, redraw) {
    box.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-form]'); if (!f) return;
      e.preventDefault();
      var inp = f.querySelector('input'), em = inp.value.trim(), err = f.querySelector('[data-err]');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em)) { err.hidden = false; inp.focus(); return; }
      err.hidden = true;
      var b = f.querySelector('button'); b.disabled = true; b.textContent = 'Sending';
      subscribe(em, repProps(extra()), repData());
      REP.email = em; REP.open = true;
      try { localStorage.setItem('pec_report', JSON.stringify({ email: em })); } catch (err2) {}
      redraw();
      var d = box.querySelector('.pcb-done'); if (d) d.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  function syncUrl(params) {
    var u = new URL(location.href);
    Object.keys(params).forEach(function (k) { if (params[k] === '' || params[k] == null) u.searchParams.delete(k); else u.searchParams.set(k, params[k]); });
    history.replaceState(null, '', u.toString());
  }

  // Focus on the calculator: the page under it is dimmed and clears as he scrolls on (once cleared, it stays clear).
  // Visual only. One fixed layer added by JS that ignores clicks. Nothing is hidden, moved or removed, so the HTML reads the same for search engines and the layout never shifts.
  (function spotlight() {
    var calc = document.querySelector('.pck');
    if (!calc || location.hash) return;
    var dim = document.createElement('div'), raf = 0, ro = null, root = document.documentElement;
    dim.className = 'pck-dim'; dim.setAttribute('aria-hidden', 'true');
    calc.parentNode.appendChild(dim);
    root.classList.add('pck-spot');
    function stop() {
      removeEventListener('scroll', req); removeEventListener('resize', req); document.removeEventListener('focusin', onFocus);
      if (ro) ro.disconnect();
      if (dim.parentNode) dim.parentNode.removeChild(dim);
      root.classList.remove('pck-spot');
    }
    // full dim while the calculator's bottom edge is low on the screen, gone once it is in the top quarter
    function frame() {
      raf = 0;
      var vh = window.innerHeight, b = calc.getBoundingClientRect().bottom, k = Math.max(0, Math.min(1, (b / vh - 0.25) / 0.35));
      if (!k) { stop(); return; }
      dim.style.transform = 'translateY(' + Math.round(b) + 'px)';
      dim.style.opacity = k.toFixed(3);
    }
    function req() { if (!raf) raf = requestAnimationFrame(frame); }
    // tabbing past the calculator clears it too
    function onFocus(e) { if (!calc.contains(e.target) && (calc.compareDocumentPosition(e.target) & 4)) stop(); }
    addEventListener('scroll', req, { passive: true }); addEventListener('resize', req); document.addEventListener('focusin', onFocus);
    if (window.ResizeObserver) { ro = new ResizeObserver(req); ro.observe(calc); }
    frame();
  })();

  window.PEC = { D: D, M: M, E: E, C: C, P: P, esc: esc, usd: usd, local: local, cname: cname, inName: inName, flag: flag, icon: icon, yrs: yrs, cell: cell, priced: priced,
    cost: cost, repeats: repeats, fits: fits, home: home, paid: paid, geo: geo, geoSaved: geoSaved, geoFetch: geoFetch, countUp: countUp, picker: picker, homeCard: homeCard, subscribe: subscribe, syncUrl: syncUrl,
    report: report, bindReport: bindReport, cap: cap };
})();
